module.exports = {
	props: {
		data: {
			required: true,
			type: Object
		},
		options: {
			type: Object,
			default: function() {
				return {
					cutoutPercentage: 90,
					tooltips: { enabled: false }, 
					hover: { mode: false }, 
					// legend: { 
					// 	position: 'bottom', 
					// 	onClick: function() { return false; }, 
					// 	labels: { boxWidth: 12, fontColor: '#2b2b2b'} 
					// } 
				}
			}
		}
	},

	mounted() {
		this.renderChart(this.data, this.options);
	}
};
